import { downloadFile } from '@mi-front/core';
import DownloadIcon from '@mui/icons-material/Download';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { AdaptiveButton } from '../../../../../../../../../components/base/AdaptiveButton';

export function DownloadExportBtn({
  fetchUrl,
  buttonsVariant = 'short',
}: {
  fetchUrl: () => Promise<string>;
  buttonsVariant?: 'short' | 'long';
}) {
  const [fetching, setFetching] = useState(false);
  const { $t } = useIntl();
  return (
    <AdaptiveButton
      text={$t({
        id: 'audit.aod.actions.downloadExport',
        defaultMessage: 'Descargar export',
      })}
      icon={<DownloadIcon />}
      display={buttonsVariant}
      color="info"
      size="small"
      disabled={fetching}
      onClick={() => {
        fetchUrl().then((url) => {
          downloadFile(url, false);
          setFetching(false);
        });

        setFetching(true);
      }}
    />
  );
}
